import { useContext } from "react";
import { ensure } from "sprint-common-web";

import { useMuxSpecificationApi } from "../../../../../common/api/orders-api/mux-specification/useMuxSpecificationApi";
import { MuxSpecificationListingContext } from "../../../context/MuxSpecificationListingContext";
import { CloneMuxSpecificationFormInputs } from "./CloneMuxSpecificationForm";

export const useCloneMuxSpecificationForm = () => {
    const { cloneMuxSpecification: cloneMuxSpec } = useMuxSpecificationApi();
    const { add: addMuxSpeficicationToContext, items } = useContext(MuxSpecificationListingContext);

    const cloneMuxSpecification = async (id: string, inputs: CloneMuxSpecificationFormInputs) => {
        const itemToClone = items.find((item) => item.id === id);
        ensure(itemToClone);

        const response = await cloneMuxSpec({
            id: itemToClone.id,
            name: inputs.name
        });

        addMuxSpeficicationToContext({
            ...itemToClone,
            id: response.entityId,
            name: inputs.name,
            updatedDate: new Date().toISOString(),
            isModified: true
        });
    };

    return {
        cloneMuxSpecification
    };
};
